module.exports = __webpack_public_path__ + "img/logo.c4d735e0.png";